import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { produce } from "../../../../../../../../../libs/immer";
import { unformatValue, validateAccountNumber } from "../../../../../PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput/utils";
import { EPaymentMethod } from "../../../../../../../../dependencies/getContent/constants";
export function checkHasPhoneInput(state) {
  var _state$scenario;
  if (((_state$scenario = state.scenario) === null || _state$scenario === void 0 ? void 0 : _state$scenario.type) === EPaymentMethod.SberPay && state.scenario.phoneInput !== undefined) return;
  throw new Error("Doesn't have a phone input");
}
export var validatePhoneUseCase = function validatePhoneUseCase(_ref) {
  var getContent = _ref.getContent,
    getIsBeelineError = _ref.getIsBeelineError;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value, setState) {
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            result = unformatValue(value);
            setState(function (prev) {
              checkHasPhoneInput(prev);
              return produce(prev, function (draft) {
                draft.scenario.phoneInput.isDisabled = true;
                draft.scenario.phoneInput.isLoading = true;
              });
            });
            _context.next = 4;
            return validateAccountNumber(result, getIsBeelineError, getContent().phoneInputErrorTexts).then(function (error) {
              setState(function (prev) {
                checkHasPhoneInput(prev);
                return produce(prev, function (draft) {
                  draft.scenario.phoneInput.errorMessage = error;
                });
              });
            }).finally(function () {
              setState(function (prev) {
                checkHasPhoneInput(prev);
                return produce(prev, function (draft) {
                  draft.scenario.phoneInput.isDisabled = false;
                  draft.scenario.phoneInput.isLoading = false;
                });
              });
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};